exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-f4f2ae04] .el-form-item__content {\n  width: 100%;\n}\n[data-v-f4f2ae04] .no-border .el-input__inner {\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  border-radius: 0;\n  width: 100%;\n}\n[data-v-f4f2ae04] .el-form-item__label {\n  width: 85px;\n}\n", ""]);

// exports
